module.exports = __webpack_public_path__ + "static/media/BlackWhiteFilter.1bbc73ec.svg";